import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild,OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { EducationalStatusService } from '@ascschool/services/category/educational-status.service';
import { StudyModeService } from '@ascschool/services/category/study-mode.service';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { NeedForEducationalSpService } from '@ascschool/services/survey/need-for-educational-sp.service';
import { WardService } from '@ascschool/services/category/ward.service';
@Component({
  selector: 'app-bc-tt-nkt-phieu',
  templateUrl: './bc-tt-nkt-phieu.component.html',
  styleUrls: ['./bc-tt-nkt-phieu.component.scss']
})
export class BCPhieuThongTinNguoiKhuyetTatComponent implements OnInit,OnDestroy, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private authQuery: AuthQuery,
    private service: BaocaoService, public utilService: UtilsService, private disProvincesService: ProvinceService,
    private districtService: DistrictService, private typeOfDisabilityService: TypeOfDisabilityService,
    private levelService: LevelService, private caDisEducationalStatusesService: EducationalStatusService,
    private disStudyModeService: StudyModeService, private modesOfEducationService: ModesOfEducationService,
    private educationalSupportService: NeedForEducationalSpService, private wardService : WardService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
   }
  get breadcrumbs(): string[] {
    return ['Báo cáo về người khuyết tật'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content;
    }
  }
 
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  // pageOptBtn: BtnOptionExtend[] = [new BtnOptionExtend('Thêm', 'plus', this.AddProvince.bind(this), null, null, Nztheme.OUTLINE, 'text-green-600')]
  $unSubscribe= new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  pageIndex = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading = true;
  Total = 0;
  firstRowOnPage: any;
  dataTable: any;
  width: number;
  numberControl: number;
  currentUser: any;
  private elementPageHeaderTable: ElementRef; 
  private elementPageHeaderTable2: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  isCollapse = true;
  year = '';
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; ProvinceControl = new FormControl();
  getDisProvincesACFn: (value: any) => Observable<any>; DisProvincesSubscription: any; DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; DistrictControl = new FormControl();
  getWardACFn: (value: any) => Observable<any>; WardSubscription: any; WardControl = new FormControl();
  getTypeOfDisabilityACFn: (value: any) => Observable<any>; TypeOfDisabilitySubscription: any; TypeOfDisabilityControl = new FormControl();
  getLevelACFn: (value: any) => Observable<any>; LevelSubscription: any; LevelControl = new FormControl();
  getCaDisEducationalStatusessACFn: (value: any) => Observable<any>; caDisEducationalStatusesSubscription: any; caDisEducationalStatusesControl = new FormControl();
  getModesOfEducation: (value: any) => Observable<any>; ModesOfEducationSubscription: any; ModesOfEducationControl = new FormControl();
  getEducationalSupport: (value: any) => Observable<any>; EducationalSupportSubscription: any; EducationalSupportControl = new FormControl();
  getDisStudyModeACFn: (value: any) => Observable<any>; DisStudyModeSubscription: any; DisStudyModeControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    if (this.currentUser.accountType === 3) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
       
        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
     
      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName });
        
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          }); 
        }
      }); 
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.disProvincesService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.DisProvincesControl.setValue({ id: res.id, text: res.provinceName }); 
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        } 
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });
      
    }
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.reload();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.checkCaculateHeight();
    this.commonFilter.year = this.year;
    this.loadDisProvinces();
    this.loadDistrict();
    this.loadTypeOfDisability();
    this.loadLevel();
    this.loadCaDisEducationalStatuses();
    this.loadModesOfEducation();
    this.loadEducationalSupport();
    this.loadDisStudyMode();
    this.commonFilter.year = this.year;
  }
  changeYear() {
    this.commonFilter.year = this.year;
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    this.commonFilter.year = this.year;
    this.service.getRpttnkt(this.commonFilter)
    .pipe(takeUntil(this.$unSubscribe)).subscribe((response: any) => { 
      const list = response.results ? response.results : [];
      this.Total = response && response.rowCount ? response.rowCount : 0;
      this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
      _this.dataTable = list ? list : [];
      _this.loading = false;
    }, (err: any) => {
      _this.dataTable = [];
      _this.loading = false;
    });
  }

  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }

  exportExcel() {
    this.commonFilter.year = this.year;
    this.service.exportRpttnkt(this.commonFilter).subscribe((data:any) => {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'BaoCaoThongKeVeThongTinNKT.xlsx';
      link.click();
    });
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }

  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }

  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => console.log('alt + n'), preventDefault: true
    });
    this.cdRef.detectChanges();
  }

  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }

  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 6000;
    }, 1);
  }

  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable, 
      this.elementPageHeaderTable2,
      this.heightPagnagation
    );
  }

  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }

  onResize() {
    this.width = 6000;
    this.checkCaculateHeight(this.isCollapse);
  }

  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }

  resetForm(): void { }
  // tslint:disable-next-line: adjacent-overload-signatures
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    if (control.value) {
      this.DistrictControl = control;
      this.loadWard();
    }
    this.WardControl.setValue(null);
  }

  loadWard() {
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, districtId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.WardSubscription) {
      this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.WardControl.value);
      });
    }
  }

  changeWard(control: FormControl) {
    if (control.value) {
      this.WardControl = control;
    }
  }


  loadTypeOfDisability() {
    this.getTypeOfDisabilityACFn = (value: any) => this.typeOfDisabilityService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfDisabilitySubscription) {
      this.TypeOfDisabilitySubscription = this.TypeOfDisabilityControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.TypeOfDisabilityControl.value);
      });
    }
  }
  changeTypeOfDisability(control: FormControl) {
    this.TypeOfDisabilityControl = control;
  }

  loadLevel() {
    this.getLevelACFn = (value: any) => this.levelService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'LevelId', this.LevelControl.value);
      });
    }
  }
  changeLevel(control: FormControl) {
    this.LevelControl = control;
  }

  loadCaDisEducationalStatuses() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisEducationalStatusessACFn = (value: any) => this.caDisEducationalStatusesService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.caDisEducationalStatusesSubscription) {
      this.caDisEducationalStatusesSubscription = this.caDisEducationalStatusesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'EducationalStatusId', this.caDisEducationalStatusesControl.value);
      });
    }
  }
  changeCaDisEducationalStatuses(control: FormControl) {
    this.caDisEducationalStatusesControl = control;
  }

  loadModesOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getModesOfEducation = (value: any) => this.modesOfEducationService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.ModesOfEducationSubscription) {
      this.ModesOfEducationSubscription = this.ModesOfEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ModesOfEducationId', this.ModesOfEducationControl.value);
      });
    }
  }
  changeModesOfEducation(control: FormControl) {
    this.ModesOfEducationControl = control;
  }

  loadEducationalSupport() {
    // tslint:disable-next-line: max-line-length
    this.getEducationalSupport = (value: any) => this.educationalSupportService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.EducationalSupportSubscription) {
      this.EducationalSupportSubscription = this.EducationalSupportControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'InterventionStatusId', this.EducationalSupportControl.value);
      });
    }
  }
  changeEducationalSupport(control: FormControl) {
    this.EducationalSupportControl = control;
  }

  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) =>
      this.disStudyModeService.getSelectPaging({
        searchTerm: value, PageIndex: 1, PageSize: 100
      }).pipe(map((resp) =>
        resp.results.length > 0
          ? resp.results.map((x) => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.DisStudyModeSubscription) {
      this.DisStudyModeSubscription = this.DisStudyModeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'StudyModeId', this.DisStudyModeControl.value);
      });
    }
  }

  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.DisStudyModeControl = control;
  }
  clear() {
    this.year = '';
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.TypeOfDisabilityControl.setValue(null);
    this.LevelControl.setValue(null);
    this.caDisEducationalStatusesControl.setValue(null);
    this.ModesOfEducationControl.setValue(null);
    this.EducationalSupportControl.setValue(null);
    this.DisStudyModeControl.setValue(null);
    this.reload();
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}
}
